(function (module) {
    "use strict";

    module.component('mkshrInYearsEditor', {
        template: require('./mkshrInYearsEditorComponent.html'),
        bindings: {
            brandMkshr: "=",
            forecastStartDate: "<",
            onMkshrChanged: '&',
            isEditable: "<"
        },
        controller: ['$scope', function(this: $TSFixMe, $scope: $TSFixMe) {
            var $ctrl = this;
            $scope.range = function (from: $TSFixMe, to: $TSFixMe) {
                
                return _.range(from, to);
            }

            $ctrl.showAllValues = false;

            var applyMksrhInYear = function (startIndex: $TSFixMe, endIndex: $TSFixMe, startValue: $TSFixMe, endValue: $TSFixMe) {
                if (startValue != null)
                    $ctrl.brandMkshr[startIndex] = startValue;

                if (endValue != null)
                    $ctrl.brandMkshr[endIndex] = endValue;

                if (startValue == null || endValue == null)
                    return;

                var x = (endValue - startValue) / (endIndex - startIndex);
                for (var index = startIndex; index <= endIndex; index++) {
                    $ctrl.brandMkshr[index] = startValue + x * (index - startIndex);
                }

                if (!angular.isUndefinedOrNull($ctrl.onMkshrChanged))
                    $ctrl.onMkshrChanged();
            }

            $ctrl.startMonthChanged = function (year: $TSFixMe, value: $TSFixMe) {
                if (isNaN(value))
                    return;
                var startMonthIndex = (year - $ctrl.startYear) * 12 + $ctrl.startIndex;
                var endMonthIndex = startMonthIndex + 11;
                applyMksrhInYear(startMonthIndex, endMonthIndex, value, $ctrl.brandMkshr[endMonthIndex]);
            }

            $ctrl.endMonthChagned = function (year: $TSFixMe, value: $TSFixMe) {
                if (isNaN(value))
                    return;
                var startMonthIndex = (year - $ctrl.startYear) * 12 + $ctrl.startIndex;
                var endMonthIndex = startMonthIndex + 11;
                applyMksrhInYear(startMonthIndex, endMonthIndex, $ctrl.brandMkshr[startMonthIndex], value);
            }


            $ctrl.$onInit = function () {
                $scope.$watch('$ctrl.brandMkshr', function () {
                    if (!$ctrl.brandMkshr)
                        return;
                    
                    var startDateMoment = moment($ctrl.forecastStartDate);
                    
                    var currentEditoStartDate = moment($ctrl.forecastStartDate).add(2, 'years').startOf('year');
                    $ctrl.startYear = currentEditoStartDate.year();

                    $ctrl.startIndex = Math.floor(currentEditoStartDate.diff(startDateMoment, 'months', true) + 0.5);
                    var years = [];

                    var currntYear = $ctrl.startYear;
                    for (var i = $ctrl.startIndex; i < $ctrl.brandMkshr.length; i += 12) {
                        var decemberIndex = i + 11;
                        years.push({
                            year: currntYear++,
                            january: $ctrl.brandMkshr[i],
                            december: decemberIndex < $ctrl.brandMkshr.length ? $ctrl.brandMkshr[decemberIndex] : null,
                            januaryIndex: i,
                            decemberIndex: decemberIndex < $ctrl.brandMkshr.length ? $ctrl.brandMkshr.length - 1 : decemberIndex
                        });
                    }

                    $ctrl.mkshrInYears = years;


                });
            };


        }]
    })

})(angular.module('topline.modules'));